module.exports = __webpack_public_path__ + "img/symbol_8.76ba5a13.png";